module.exports = __webpack_public_path__ + "img/case2.1872e4a5.png";